'use strict';

const loginEvents = require('theme/js/login/login');
const processInclude = require('theme/js/util');
const clientSideValidation = require('../components/clientSideValidation');

function closeLoginModal() {
    $('.js-login-modal').removeClass('show');
    $('body').removeClass('overflow-hidden');
    $('.login-modal-overlay').addClass('hide');
}

function openLoginModal() {
    $('.js-login-modal').addClass('show');
    $('body').addClass('overflow-hidden');
    $('.login-modal-overlay').removeClass('hide');
}

function addSwipeCloseEventListeners() {
    let startX = 0;
    let endX = 0;
    const loginModal = $('.js-login-modal');

    loginModal.on('touchstart', function (e) {
        startX = e.originalEvent.touches[0].clientX;
    });

    loginModal.on('touchend', function (e) {
        endX = e.originalEvent.changedTouches[0].clientX;
        let diffX = endX - startX;

        if (diffX > 50) { // Swipe right threshold
            closeLoginModal();
        }
    });
}

function addNavigationEventListeners() {
    const $modal = $('.login-modal');

    $modal.find('.tab-button').on('click', function (e) {
        e.preventDefault();
        const tabId = $(this).data('tab-id');
        activateTab($modal, tabId);
    });

    $('.become-member-link').on('click', function (e) {
        e.preventDefault();
        activateTab($modal, 2);
    });

    $('.login-link').on('click', function (e) {
        e.preventDefault();
        activateTab($modal, 1);
    });
}

function activateTab($modal, tabId) {
    $modal.find('.tab-content').removeClass('active');
    $modal.find(`.tab-content[data-tab-id="${tabId}"]`).addClass('active');

    $modal.find('.tab-button').removeClass('active');
    $modal.find(`.tab-button[data-tab-id="${tabId}"]`).addClass('active');
}

function addPopupCloseEventListeners() {
    $('body').on('click', '.close-login-modal', function () {
        closeLoginModal();
    });

    $('body').on('click', '.login-modal-overlay', function () {
        closeLoginModal();
    });

    addSwipeCloseEventListeners();
}

function renderLoginModal(openRegistrationPage) {
    $.ajax({
        url: window.SitePreferences.RENDER_LOGIN_DRAWER_URL,
        method: 'GET',
        success: function (data) {
            $('body').append(data);

            addNavigationEventListeners();
            addPopupCloseEventListeners();

            setTimeout(function () {
                openLoginModal();
                if (openRegistrationPage) {
                    activateTab($('.login-modal'), 2);
                }
            }, 20);

            // Login and registration form event listeners
            processInclude(loginEvents);

            // Initialize client-side validation only for the newly rendered login and registration forms.
            // Avoid affecting other existing forms on the site by scoping event listeners to these elements only.
            ['form[name="login-form"]', '.registration'].forEach(function (selector) {
                clientSideValidation.buttonClick(selector);
                clientSideValidation.invalid(selector);
                clientSideValidation.submit(selector);
            });
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
        }
    });
}

function addOpenModalEventListeners() {
    $('body').on('click', 'a[href*="/login"]', function (e) {
        const href = $(this).attr('href');

        if (href.includes('loginstatic=true')) {
            return;
        }

        if (!window.SitePreferences.LOGIN_DRAWER_ENABLED) {
            return;
        }

        e.preventDefault();

        const loginModalIsRendered = $('.js-login-modal').length > 0;
        const openRegistrationPage = href.includes('becomemember=true');

        if (loginModalIsRendered) {
            openLoginModal();
            if (openRegistrationPage) {
                activateTab($('.login-modal'), 2);
            } else {
                activateTab($('.login-modal'), 1);
            }
        } else {
            renderLoginModal(openRegistrationPage);
        }
    });
}

function checkAndRenderModalBasedOnUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const loginPopup = urlParams.get('loginpopup');
    const openRegistrationPage = urlParams.get('memberpopup');


    if (loginPopup || openRegistrationPage) {
        renderLoginModal(openRegistrationPage);
        openLoginModal();
    }
}

jQuery(function () {
    // Initialize modal events
    addOpenModalEventListeners();
    checkAndRenderModalBasedOnUrlParams();
});

